import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from 'domains/merchant-inventory-batch-item/molecules/table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.func
  })
}

const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    buttonText       : 'Process',
    buttonColour     : 'default',
    onButtonClick    : () => {},
    isButtonDisabled : () => {}
  }
}


/**
 * Table to display Merchant Inventory Batches Items
 * this table works as general table for showing inv batch items with received_status ===  'pending'
 * @param {Array<Object>} data - array of inventory_batch objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {String} tableStatus - table status constant (from the merchant inventory batch item constant)
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantInventoryBatchItemTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps

  const columns = useMemo(
    () => tableColumns({
      buttonText,
      buttonColour,
      onButtonClick,
      isButtonDisabled
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled
    ]
  )


  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

MerchantInventoryBatchItemTable.propTypes    = propTypes
MerchantInventoryBatchItemTable.defaultProps = defaultProps

export default MerchantInventoryBatchItemTable
